import { render, staticRenderFns } from "./retention.vue?vue&type=template&id=197a9758&scoped=true"
import script from "./retention.vue?vue&type=script&lang=ts"
export * from "./retention.vue?vue&type=script&lang=ts"
import style0 from "./retention.vue?vue&type=style&index=0&id=197a9758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197a9758",
  null
  
)

export default component.exports